export default __webpack_public_path__ + "static/media/Sliver of Pure Ice (dexterity).02647dbb.jpg";